export const RCSCampaignSummary = (builder) => ({
    RCSCampaignSummary: builder.mutation({
        query: ({ page, limit, search, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_RCS_API_PORT + '/rcs_campaign_summary',
                method: 'GET',
                params: { page, limit, search, startDate, endDate },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});